<div [ngStyle]="{'position': !forMobile?'relative':'absolute'}">
	<div [ngStyle]="{'overflow': 'auto', 'height': 'auto', 'margin-top':'10px'}">
		<div class="territoryCardDescriptionText" *ngIf="normalizedData.Description !== null" style="margin-bottom: 10px;">
			{{normalizedData.Description}}
			<span *ngIf="normalizedData.CIPCode!= null && normalizedData.CIPCode!==''" (click)="showCIPDetail()" role="button"><i class="jmInfoCircle"></i></span>
		</div>

		<div *ngIf="normalizedData.tCardType==tCardType.Career">
			<div *ngIf="normalizedData.Depth <= 2">
				<table style="margin-top: 10px;">
					<tr class="territoryCardBackOfCardItemRow">
						<td>
							<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnSignsPost"></i></div>
						</td>
						<td>
							<div class="territoryCardBackOfCardItemText">Occupation Pathways</div>
							<br />
							<div class="territoryCardBackOfCardItemText">{{toCommaNumber(normalizedData.PathwayTotal)}}</div>
						</td>
					</tr>
					<tr class="territoryCardBackOfCardRowSpacer">
						<td colspan="2"></td>
					</tr>
					<tr class="territoryCardBackOfCardItemRow">
						<td>
							<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnBriefcase"></i></div>
						</td>
						<td>
							<div class="territoryCardBackOfCardItemText">Occupation Choices</div>
							<br />
							<div class="territoryCardBackOfCardItemText">{{toCommaNumber(normalizedData.OccupationTotal)}}</div>
						</td>
					</tr>
					<tr class="territoryCardBackOfCardRowSpacer">
						<td colspan="2"></td>
					</tr>
					<tr class="territoryCardBackOfCardItemRow">
						<td>
							<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnTrophy"></i></div>
						</td>
						<td>
							<div class="territoryCardBackOfCardItemText">Skills</div>
							<br />
							<div class="territoryCardBackOfCardItemText">{{toCommaNumber(normalizedData.SkillTotal)}}</div>
						</td>
					</tr>
					<tr class="territoryCardBackOfCardRowSpacer">
						<td colspan="2"></td>
					</tr>
					<tr>
						<td>
							<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnLinode"></i></div>
						</td>
						<td>
							<div class="territoryCardBackOfCardItemText">Abilities</div>
							<br />
							<div class="territoryCardBackOfCardItemText">{{toCommaNumber(normalizedData.AbilityTotal)}}</div>
						</td>
					</tr>
					<tr class="territoryCardBackOfCardRowSpacer">
						<td colspan="2"></td>
					</tr>
					<tr>
						<td>
							<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnLightbulb"></i></div>
						</td>
						<td>
							<div class="territoryCardBackOfCardItemText">Knowledge Choices</div>
							<br />
							<div class="territoryCardBackOfCardItemText">{{toCommaNumber(normalizedData.KnowledgeTotal)}}</div>
						</td>
					</tr>
					<tr class="territoryCardBackOfCardRowSpacer">
						<td colspan="2"></td>
					</tr>
					<tr>
						<td>
							<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnCode"></i></div>
						</td>
						<td>
							<div class="territoryCardBackOfCardItemText">Technology Choices</div>
							<br />
							<div class="territoryCardBackOfCardItemText">{{toCommaNumber(normalizedData.TechnologyTotal)}}</div>
						</td>
					</tr>
					<tr class="territoryCardBackOfCardRowSpacer">
						<td colspan="2"></td>
					</tr>
					<tr>
						<td>
							<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnListOl"></i></div>
						</td>
						<td>
							<div class="territoryCardBackOfCardItemText">Task</div>
							<br />
							<div class="territoryCardBackOfCardItemText">{{toCommaNumber(normalizedData.TaskTotal)}}</div>
						</td>
					</tr>
					<tr class="territoryCardBackOfCardRowSpacer">
						<td colspan="2"></td>
					</tr>
					<tr>
						<td>
							<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnGear"></i></div>
						</td>
						<td>
							<div class="territoryCardBackOfCardItemText">Work Activities</div>
							<br />
							<div class="territoryCardBackOfCardItemText">{{toCommaNumber(normalizedData.WorkActivitiyTotal)}}</div>
						</td>
					</tr>
					<tr class="territoryCardBackOfCardRowSpacer">
						<td colspan="2"></td>
					</tr>
				</table>
			</div>
			<div *ngIf="normalizedData.Depth===3">
				<table style="margin-top: 10px;">
					<tr>
						<td>
							<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnBriefcase"></i></div>
						</td>
						<td>
							<div class="territoryCardBackOfCardItemText">Occupation Choices</div>
							<br />
							<div class="territoryCardBackOfCardItemText">{{toCommaNumber(normalizedData.OccupationTotal)}}</div>
						</td>
					</tr>
					<tr class="territoryCardBackOfCardRowSpacer">
						<td colspan="2"></td>
					</tr>
					<tr>
						<td>
							<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnTrophy"></i></div>
						</td>
						<td>
							<div class="territoryCardBackOfCardItemText">Skills</div>
							<br />
							<div class="territoryCardBackOfCardItemText">{{toCommaNumber(normalizedData.SkillTotal)}}</div>
						</td>
					</tr>
					<tr class="territoryCardBackOfCardRowSpacer">
						<td colspan="2"></td>
					</tr>
					<tr>
						<td>
							<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnLinode"></i></div>
						</td>
						<td>
							<div class="territoryCardBackOfCardItemText">Abilities</div>
							<br />
							<div class="territoryCardBackOfCardItemText">{{toCommaNumber(normalizedData.AbilityTotal)}}</div>
						</td>
					</tr>
					<tr class="territoryCardBackOfCardRowSpacer">
						<td colspan="2"></td>
					</tr>
					<tr>
						<td>
							<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnLightbulb"></i></div>
						</td>
						<td>
							<div class="territoryCardBackOfCardItemText">Knowledge Choices</div>
							<br />
							<div class="territoryCardBackOfCardItemText">{{toCommaNumber(normalizedData.KnowledgeTotal)}}</div>
						</td>
					</tr>
					<tr class="territoryCardBackOfCardRowSpacer">
						<td colspan="2"></td>
					</tr>
					<tr>
						<td>
							<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnCode"></i></div>
						</td>
						<td>
							<div class="territoryCardBackOfCardItemText">Technology Choices</div>
							<br />
							<div class="territoryCardBackOfCardItemText">{{toCommaNumber(normalizedData.TechnologyTotal)}}</div>
						</td>
					</tr>
					<tr class="territoryCardBackOfCardRowSpacer">
						<td colspan="2"></td>
					</tr>
					<tr>
						<td>
							<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnListOl"></i></div>
						</td>
						<td>
							<div class="territoryCardBackOfCardItemText">Task</div>
							<br />
							<div class="territoryCardBackOfCardItemText">{{toCommaNumber(normalizedData.TaskTotal)}}</div>
						</td>
					</tr>
					<tr class="territoryCardBackOfCardRowSpacer">
						<td colspan="2"></td>
					</tr>
					<tr>
						<td>
							<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnGear"></i></div>
						</td>
						<td>
							<div class="territoryCardBackOfCardItemText">Work Activities</div>
							<br />
							<div class="territoryCardBackOfCardItemText">{{toCommaNumber(normalizedData.WorkActivitiyTotal)}}</div>
						</td>
					</tr>
					<tr class="territoryCardBackOfCardRowSpacer">
						<td colspan="2"></td>
					</tr>
				</table>
			</div>
			<div *ngIf="normalizedData.Depth===4">
				<table style="margin-top: 10px;">
					<tr class="territoryCardBackOfCardItemRow">
						<td>
							<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnGraduationCap"></i></div>
						</td>
						<td>
							<div class="territoryCardBackOfCardItemText" style="line-height: 37.5px;">Typical Degree</div>
						</td>
					</tr>
					<ng-container *ngIf="hasDegreeData">
						<tr *ngFor="let degree of sortedDegrees | slice:0:3" style="width: 100%;">
							<td></td>
							<td>
								<div class="territoryCardBackOfCardItemText">{{getEducationDegree(degree.degreeName)}} - {{degree.percent}}%</div>
							</td>
						</tr>
					</ng-container>
					<tr class="territoryCardBackOfCardItemRow" *ngIf="!hasDegreeData">
						<td></td>
						<td>
							<div class="territoryCardAtAGlanceData">N/A</div>
						</td>
					</tr>
					<tr class="territoryCardBackOfCardRowSpacer">
						<td colspan="2"></td>
					</tr>
					<tr class="territoryCardBackOfCardItemRow">
						<td>
							<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnDollarSign"></i></div>
						</td>
						<td>
							<div class="territoryCardBackOfCardItemText">Average Annual Salary</div>
						</td>
					</tr>
					<tr class="territoryCardBackOfCardItemRow">
						<td></td>
						<td>
							<div class="territoryCardBackOfCardItemText">{{normalizedData.AverageAnnualSalary == null|| normalizedData.AverageAnnualSalary.trim() == "" ? 'N/A': normalizedData.AverageAnnualSalary}}</div>
						</td>
					</tr>
					<tr class="territoryCardBackOfCardRowSpacer">
						<td colspan="2"></td>
					</tr>
					<tr class="territoryCardBackOfCardItemRow">
						<td>
							<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnArrowUp"></i></div>
						</td>
						<td>
							<div class="territoryCardBackOfCardItemText">Projected Growth</div>
						</td>
					</tr>
					<tr>
						<td></td>
						<td class="territoryCardBackOfCardItemText">
							<div>{{normalizedData.ProjectedEmploymentGrowthPercent==null || normalizedData.ProjectedEmploymentGrowthPercent.trim() == ""? "N/A": convertToPercent(normalizedData.ProjectedEmploymentGrowthPercent)}}</div>
							<ng-container *ngIf="normalizedData.ProjectedEmploymentGrowthAverage != null && normalizedData.ProjectedEmploymentGrowthAverage.trim() !==''">
								<i class="{{getGrowthDisplay().img}}"></i>
								<div style="display: inline; margin-left: 5px;">{{getGrowthDisplay().display}}</div>
							</ng-container>
						</td>
					</tr>
					<tr class="territoryCardBackOfCardRowSpacer">
						<td colspan="2"></td>
					</tr>
					<tr class="territoryCardBackOfCardItemRow">
						<td>
							<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnChartLine"></i></div>
						</td>
						<td>
							<div class="territoryCardBackOfCardItemText">Projected Job Openings</div>
						</td>
					</tr>
					<tr>
						<td></td>
						<td>
							<div class="territoryCardBackOfCardItemText">
								{{normalizedData.ProjectedJobOpenings==null || normalizedData.ProjectedJobOpenings.trim() == "" ? "N/A" : formatFraction(normalizedData.ProjectedJobOpenings) }}
							</div>
						</td>
					</tr>
					<tr class="territoryCardBackOfCardRowSpacer">
						<td colspan="2"></td>
					</tr>
					<tr class="territoryCardBackOfCardItemRow">
						<td>
							<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnBriefcase"></i></div>
						</td>
						<td>
							<div class="territoryCardBackOfCardItemText">Currently Employed</div>
						</td>
					</tr>
					<tr>
						<td></td>
						<td>
							<div class="territoryCardBackOfCardItemText">
								{{normalizedData.CurrentEmployment==null || normalizedData.CurrentEmployment.trim() == "" ? "N/A" : formatFraction(normalizedData.CurrentEmployment)}}
							</div>
						</td>
					</tr>
					<tr class="territoryCardBackOfCardRowSpacer">
						<td colspan="2"></td>
					</tr>
					<tr class="territoryCardBackOfCardItemRow">
						<td>
							<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnNewspaper"></i></div>
						</td>
						<td>
							<div class="territoryCardBackOfCardItemText">ONet Code</div>
						</td>
					</tr>
					<tr>
						<td></td>
						<td>
							<div class="territoryCardBackOfCardItemText">
								<a href="https://www.onetonline.org/link/summary/{{normalizedData.OccupationCode}}" target="_blank" rel="noopener noreferrer">{{normalizedData.OccupationCode}}</a>
							</div>
						</td>
					</tr>
					<tr class="territoryCardBackOfCardRowSpacer">
						<td colspan="2"></td>
					</tr>
				</table>
			</div>
		</div>

		<div *ngIf="normalizedData.tCardType===tCardType.College">
			<div *ngIf="normalizedData.Depth===0">
				<table style="margin-top: 10px;">
					<tr class="territoryCardBackOfCardItemRow">
						<td>
							<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnConnectdevelop"></i></div>
						</td>
						<td>
							<div class="territoryCardBackOfCardItemText">College Clusters</div>
							<br />
							<div class="territoryCardBackOfCardItemText">{{normalizedData.ClusterTotal}}</div>
						</td>
					</tr>
					<tr class="territoryCardBackOfCardRowSpacer">
						<td colspan="2"></td>
					</tr>
					<tr class="territoryCardBackOfCardItemRow">
						<td>
							<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnGraduationCap"></i></div>
						</td>
						<td>
							<div class="territoryCardBackOfCardItemText">College Pathways</div>
							<br />
							<div class="territoryCardBackOfCardItemText">{{normalizedData.ProgramTotal}}</div>
						</td>
					</tr>
					<tr class="territoryCardBackOfCardRowSpacer">
						<td colspan="2"></td>
					</tr>
					<tr class="territoryCardBackOfCardItemRow">
						<td>
							<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnPencil"></i></div>
						</td>
						<td>
							<div class="territoryCardBackOfCardItemText">Courses</div>
							<br />
							<div class="territoryCardBackOfCardItemText">{{normalizedData.CourseTotal}}</div>
						</td>
					</tr>
					<tr class="territoryCardBackOfCardRowSpacer">
						<td colspan="2"></td>
					</tr>
				</table>
			</div>
			<div *ngIf="normalizedData.Depth===2">
				<table style="margin-top: 10px;">
					<tr class="territoryCardBackOfCardItemRow">
						<td>
							<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnGraduationCap"></i></div>
						</td>
						<td>
							<div class="territoryCardBackOfCardItemText">Academic Programs</div>
							<br />
							<div class="territoryCardBackOfCardItemText">{{normalizedData.ProgramTotal}}</div>
						</td>
					</tr>
					<tr class="territoryCardBackOfCardRowSpacer">
						<td colspan="2"></td>
					</tr>
					<tr class="territoryCardBackOfCardItemRow">
						<td>
							<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnPencil"></i></div>
						</td>
						<td>
							<div class="territoryCardBackOfCardItemText">Courses</div>
							<br />
							<div class="territoryCardBackOfCardItemText">{{normalizedData.CourseTotal}}</div>
						</td>
					</tr>
					<tr class="territoryCardBackOfCardRowSpacer">
						<td colspan="2"></td>
					</tr>
				</table>
			</div>
			<div *ngIf="normalizedData.Depth===3">
				<table style="margin-top: 10px;">
					<tr class="territoryCardBackOfCardItemRow">
						<td>
							<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnGraduationCap"></i></div>
						</td>
						<td>
							<div class="territoryCardBackOfCardItemText">Number of Graduates</div>
							<br />
							<div style="font-weight: bold;" class="territoryCardBackOfCardItemText">{{normalizedData.AtAGlance_College.NumGraduates==null?'N/A':normalizedData.AtAGlance_College.NumGraduates}}</div>
						</td>
					</tr>
					<tr class="territoryCardBackOfCardRowSpacer">
						<td colspan="2"></td>
					</tr>
					<tr class="territoryCardBackOfCardItemRow">
						<td>
							<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnCreditCard"></i></div>
						</td>
						<td>
							<div class="territoryCardBackOfCardItemText">Median Total Debt</div>
							<br />
							<div style="font-weight: bold;" class="territoryCardBackOfCardItemText">{{normalizedData.AtAGlance_College.MedianTotalDebt==null?'N/A':'$'+toCommaNumber(normalizedData.AtAGlance_College.MedianTotalDebt)}}</div>
						</td>
					</tr>
					<tr class="territoryCardBackOfCardRowSpacer">
						<td colspan="2"></td>
					</tr>
					<tr class="territoryCardBackOfCardItemRow">
						<td>
							<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnDollarSign"></i></div>
						</td>
						<td>
							<div class="territoryCardBackOfCardItemText">Median Earnings</div>
							<br />
							<div style="font-weight: bold;" class="territoryCardBackOfCardItemText">{{normalizedData.AtAGlance_College.MedianEarnings==null?'N/A':'$'+toCommaNumber(normalizedData.AtAGlance_College.MedianEarnings)}}</div>
						</td>
					</tr>
					<tr class="territoryCardBackOfCardRowSpacer">
						<td colspan="2"></td>
					</tr>
					<tr class="territoryCardBackOfCardItemRow">
						<td>
							<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnFileInvoiceDollar"></i></div>
						</td>
						<td>
							<div class="territoryCardBackOfCardItemText">Monthly Loan Payment</div>
							<br />
							<div style="font-weight: bold;" class="territoryCardBackOfCardItemText">{{normalizedData.AtAGlance_College.MonthlyLoanPayment==null?'N/A':'$'+toCommaNumber(normalizedData.AtAGlance_College.MonthlyLoanPayment)}}</div>
						</td>
					</tr>
					<tr class="territoryCardBackOfCardRowSpacer">
						<td colspan="2"></td>
					</tr>
					<tr class="territoryCardBackOfCardItemRow">
						<td>
							<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnCalendarCheck"></i></div>
						</td>
						<td>
							<div class="territoryCardBackOfCardItemText">Monthly Earnings</div>
							<br />
							<div style="font-weight: bold;" class="territoryCardBackOfCardItemText">{{normalizedData.AtAGlance_College.MonthlyEarnings==null?'N/A':'$'+toCommaNumber(normalizedData.AtAGlance_College.MonthlyEarnings)}}</div>
						</td>
					</tr>
					<tr class="territoryCardBackOfCardRowSpacer">
						<td colspan="2"></td>
					</tr>
				</table>
			</div>
			<div *ngIf="normalizedData.Depth===4">
				<table style="margin-top: 10px;">
					<tr class="territoryCardBackOfCardItemRow">
						<td>
							<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnBook"></i></div>
						</td>
						<td>
							<div class="territoryCardBackOfCardItemText">Credits</div>
							<br />
							<div *ngIf="normalizedData.CreditTotal != null && normalizedData.CreditTotal > 0" class="territoryCardBackOfCardItemText">{{normalizedData.CreditTotal}}</div>
							<div *ngIf="normalizedData.CreditTotal == null || normalizedData.CreditTotal===0" class="territoryCardBackOfCardItemText">N/A</div>
						</td>
					</tr>
					<tr class="territoryCardBackOfCardRowSpacer">
						<td colspan="2"></td>
					</tr>
					<tr class="territoryCardBackOfCardItemRow">
						<td>
							<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnBlackTie"></i></div>
						</td>
						<td>
							<div class="territoryCardBackOfCardItemText">Professors</div>
							<br />
							<div *ngIf="normalizedData.ProfessorTotal == null || normalizedData.ProfessorTotal === '0'" class="territoryCardBackOfCardItemText">N/A</div>
							<div *ngIf="normalizedData.ProfessorTotal != null && normalizedData.ProfessorTotal !== '0'" class="territoryCardBackOfCardItemText">{{normalizedData.ProfessorTotal}}</div>
						</td>
					</tr>
					<tr class="territoryCardBackOfCardRowSpacer">
						<td colspan="2"></td>
					</tr>
					<tr class="territoryCardBackOfCardItemRow">
						<td>
							<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnCalendar"></i></div>
						</td>
						<td>
							<div class="territoryCardBackOfCardItemText">Class Length</div>
							<br />
							<div *ngIf="normalizedData.ClassLength != null && normalizedData.ClassLength > 0" class="territoryCardBackOfCardItemText">{{normalizedData.ClassLength}}</div>
							<div *ngIf="normalizedData.ClassLength == null || normalizedData.ClassLength===0" class="territoryCardBackOfCardItemText">N/A</div>
						</td>
					</tr>
					<tr class="territoryCardBackOfCardRowSpacer">
						<td colspan="2"></td>
					</tr>
				</table>
			</div>
		</div>

		<div *ngIf="normalizedData.tCardType === tCardType.Certification">
			<table style="margin-top: 10px;">
				<ng-container *ngIf="normalizedData.Depth === 0">
					<tr class="territoryCardBackOfCardItemRow">
						<td>
							<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnConnectdevelop"></i></div>
						</td>
						<td style="display: flex; flex-direction: column;">
							<div class="territoryCardBackOfCardItemText">Clusters</div>
							<div class="territoryCardBackOfCardItemText" style="font-weight:700;">{{normalizedData.ClusterTotal}}</div>
						</td>
					</tr>
					<tr class="territoryCardBackOfCardRowSpacer">
						<td colspan="2"></td>
					</tr>
				</ng-container>
				<ng-container *ngIf="normalizedData.Depth <= 2">
					<tr class="territoryCardBackOfCardItemRow">
						<td>
							<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnSignsPost"></i></div>
						</td>
						<td style="display: flex; flex-direction: column;">
							<div class="territoryCardBackOfCardItemText">Pathways</div>
							<div class="territoryCardBackOfCardItemText" style="font-weight:700;">{{normalizedData.PathwayTotal}}</div>
						</td>
					</tr>
					<tr class="territoryCardBackOfCardRowSpacer">
						<td colspan="2"></td>
					</tr>
				</ng-container>
				<ng-container *ngIf="normalizedData.Depth <= 3">
					<tr class="territoryCardBackOfCardItemRow">
						<td>
							<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnSiteMap"></i></div>
						</td>
						<td style="display: flex; flex-direction: column;">
							<div class="territoryCardBackOfCardItemText">Certifying Organizations</div>
							<div class="territoryCardBackOfCardItemText" style="font-weight:700;">{{normalizedData.AtAGlance_Certification.CertifyingOrganizationTotal}}</div>
						</td>
					</tr>
					<tr class="territoryCardBackOfCardRowSpacer">
						<td colspan="2"></td>
					</tr>
					<tr class="territoryCardBackOfCardItemRow">
						<td>
							<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnCertificate"></i></div>
						</td>
						<td style="display: flex; flex-direction: column;">
							<div class="territoryCardBackOfCardItemText">Certificates</div>
							<div class="territoryCardBackOfCardItemText" style="font-weight:700;">{{normalizedData.AtAGlance_Certification.CertificateTotal}}</div>
						</td>
					</tr>
				</ng-container>
				<ng-container *ngIf="normalizedData.Depth == 4">
					<tr class="territoryCardBackOfCardItemRow">
						<td>
							<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnBuildingColumns"></i></div>
						</td>
						<td style="display: flex; flex-direction: column;">
							<div class="territoryCardBackOfCardItemText">Institutions & training providers</div>
							<div class="territoryCardBackOfCardItemText" style="font-weight:700;">{{normalizedData.AtAGlance_Certification.TrainingTotal}}</div>
						</td>
					</tr>
					<tr class="territoryCardBackOfCardRowSpacer">
						<td colspan="2"></td>
					</tr>
					<tr class="territoryCardBackOfCardItemRow">
						<td>
							<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnBriefcase"></i></div>
						</td>
						<td style="display: flex; flex-direction: column;">
							<div class="territoryCardBackOfCardItemText">Occupations</div>
							<div class="territoryCardBackOfCardItemText" style="font-weight:700;">{{normalizedData.OccupationTotal}}</div>
						</td>
					</tr>
					<tr class="territoryCardBackOfCardRowSpacer">
						<td colspan="2"></td>
					</tr>
					<tr class="territoryCardBackOfCardItemRow">
						<td>
							<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnCopy"></i></div>
						</td>
						<td style="display: flex; flex-direction: column;">
							<div class="territoryCardBackOfCardItemText">Resources</div>
							<div class="territoryCardBackOfCardItemText" style="font-weight:700;">{{normalizedData.AtAGlance_Certification.ResourceTotal}}</div>
						</td>
					</tr>
					<tr class="territoryCardBackOfCardRowSpacer">
						<td colspan="2"></td>
					</tr>
					<tr class="territoryCardBackOfCardItemRow">
						<td>
							<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnGraduationCap"></i></div>
						</td>
						<td style="display: flex; flex-direction: column;">
							<div class="territoryCardBackOfCardItemText">Education and Training Required?</div>
							<div class="territoryCardBackOfCardItemText" style="font-weight:700;">{{normalizedData.AtAGlance_Certification.EducationTrainingRequired}}</div>
						</td>
					</tr>
					<tr class="territoryCardBackOfCardRowSpacer">
						<td colspan="2"></td>
					</tr>
					<tr class="territoryCardBackOfCardItemRow">
						<td>
							<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnBriefcase"></i></div>
						</td>
						<td style="display: flex; flex-direction: column;">
							<div class="territoryCardBackOfCardItemText">Work Experience Required?</div>
							<div class="territoryCardBackOfCardItemText" style="font-weight:700;">{{normalizedData.AtAGlance_Certification.WorkExperienceRequired}}</div>
						</td>
					</tr>
					<tr class="territoryCardBackOfCardRowSpacer">
						<td colspan="2"></td>
					</tr>
					<tr class="territoryCardBackOfCardItemRow">
						<td>
							<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnFilePen"></i></div>
						</td>
						<td style="display: flex; flex-direction: column;">
							<div class="territoryCardBackOfCardItemText">Exam Required?</div>
							<div class="territoryCardBackOfCardItemText" style="font-weight:700;">{{normalizedData.AtAGlance_Certification.OralWrittenExamRequired}}</div>
						</td>
					</tr>
					<tr class="territoryCardBackOfCardRowSpacer">
						<td colspan="2"></td>
					</tr>
					<tr class="territoryCardBackOfCardItemRow">
						<td>
							<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnCalendar"></i></div>
						</td>
						<td style="display: flex; flex-direction: column;">
							<div class="territoryCardBackOfCardItemText">Exam Renewal Required?</div>
							<div class="territoryCardBackOfCardItemText" style="font-weight:700;">{{normalizedData.AtAGlance_Certification.CertificateRenewal}}</div>
						</td>
					</tr>
					<tr class="territoryCardBackOfCardRowSpacer">
						<td colspan="2"></td>
					</tr>
					<tr class="territoryCardBackOfCardItemRow">
						<td>
							<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnRepeat"></i></div>
						</td>
						<td style="display: flex; flex-direction: column;">
							<div class="territoryCardBackOfCardItemText">Re-exam Required?</div>
							<div class="territoryCardBackOfCardItemText" style="font-weight:700;">{{normalizedData.AtAGlance_Certification.CertificateReexam}}</div>
						</td>
					</tr>
					<tr class="territoryCardBackOfCardRowSpacer">
						<td colspan="2"></td>
					</tr>
					<tr class="territoryCardBackOfCardItemRow">
						<td>
							<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnBuilding"></i></div>
						</td>
						<td style="display: flex; flex-direction: column;">
							<div class="territoryCardBackOfCardItemText">External Link</div>
							<div class="territoryCardBackOfCardItemText" style="font-weight:700;">
								<a href="{{normalizedData.AtAGlance_Certification.OrgUrl}}" target="_blank" rel="noopener noreferrer">{{normalizedData.AtAGlance_Certification.OrgName}}</a>
							</div>
						</td>
					</tr>
					<ng-container *ngIf="normalizedData.AtAGlance_Certification.CertificateUrl.length > 0">
						<tr class="territoryCardBackOfCardRowSpacer">
							<td colspan="2"></td>
						</tr>
						<tr class="territoryCardBackOfCardItemRow">
							<td>
								<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnCertificate"></i></div>
							</td>
							<td style="display: flex; flex-direction: column;">
								<div class="territoryCardBackOfCardItemText">External Link</div>
								<div class="territoryCardBackOfCardItemText" style="font-weight:700;">
									<a href="{{normalizedData.AtAGlance_Certification.CertificateUrl}}" target="_blank" rel="noopener noreferrer">Certificate Detail</a>
								</div>
							</td>
						</tr>
					</ng-container>
				</ng-container>
			</table>
		</div>

		<div *ngIf="normalizedData.tCardType===tCardType.K12">
			<table style="margin-top: 10px;">
				<tr class="territoryCardBackOfCardItemRow">
					<td>
						<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnBook"></i></div>
					</td>
					<td style="display: flex; flex-direction: column;">
						<div class="territoryCardBackOfCardItemText">Subjects</div>
						<div class="territoryCardBackOfCardItemText" style="font-weight:700;">{{normalizedData.SubjectsTotal}}</div>
					</td>
				</tr>
				<tr class="territoryCardBackOfCardRowSpacer">
					<td colspan="2"></td>
				</tr>
				<tr class="territoryCardBackOfCardItemRow">
					<td>
						<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnBookmark"></i></div>
					</td>
					<td style="display: flex; flex-direction: column;">
						<div class="territoryCardBackOfCardItemText">Strands</div>
						<div class="territoryCardBackOfCardItemText" style="font-weight:700;">{{normalizedData.StrandTotal}}</div>
					</td>
				</tr>
				<tr class="territoryCardBackOfCardRowSpacer">
					<td colspan="2"></td>
				</tr>
				<tr class="territoryCardBackOfCardItemRow">
					<td>
						<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnLightbulb"></i></div>
					</td>
					<td style="display: flex; flex-direction: column;">
						<div class="territoryCardBackOfCardItemText">Standards</div>
						<div class="territoryCardBackOfCardItemText" style="font-weight:700;">{{normalizedData.StandardTotal}}</div>
					</td>
				</tr>
				<tr class="territoryCardBackOfCardRowSpacer">
					<td colspan="2"></td>
				</tr>
				<tr class="territoryCardBackOfCardItemRow">
					<td>
						<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnList"></i></div>
					</td>
					<td style="display: flex; flex-direction: column;">
						<div class="territoryCardBackOfCardItemText">Benchmarks</div>
						<div class="territoryCardBackOfCardItemText" style="font-weight:700;">{{normalizedData.Benchmark}}</div>
					</td>
				</tr>
				<tr class="territoryCardBackOfCardRowSpacer">
					<td colspan="2"></td>
				</tr>
				<tr class="territoryCardBackOfCardItemRow">
					<td>
						<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnListOl"></i></div>
					</td>
					<td style="display: flex; flex-direction: column;">
						<div class="territoryCardBackOfCardItemText">SubBenchmark</div>
						<div class="territoryCardBackOfCardItemText" style="font-weight:700;">{{normalizedData.SubBenchmark}}</div>
					</td>
				</tr>
				<tr class="territoryCardBackOfCardRowSpacer">
					<td colspan="2"></td>
				</tr>
			</table>
		</div>

		<div *ngIf="normalizedData.tCardType===tCardType.CTE">
			<table style="margin-top: 10px;">
				<tr class="territoryCardBackOfCardItemRow" *ngIf="normalizedData.Depth <= 1">
					<td>
						<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnConnectdevelop"></i></div>
					</td>
					<td style="display: flex; flex-direction: column;">
						<div class="territoryCardBackOfCardItemText">Clusters</div>
						<div class="territoryCardBackOfCardItemText" style="font-weight:700;">{{normalizedData.ClusterTotal}}</div>
					</td>
				</tr>
				<tr class="territoryCardBackOfCardRowSpacer">
					<td colspan="2"></td>
				</tr>
				<tr class="territoryCardBackOfCardItemRow" *ngIf="normalizedData.Depth <= 2">
					<td>
						<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnSignsPost"></i></div>
					</td>
					<td style="display: flex; flex-direction: column;">
						<div class="territoryCardBackOfCardItemText">Pathways</div>
						<div class="territoryCardBackOfCardItemText" style="font-weight:700;">{{normalizedData.PathwayTotal}}</div>
					</td>
				</tr>
				<tr class="territoryCardBackOfCardRowSpacer">
					<td colspan="2"></td>
				</tr>
				<tr class="territoryCardBackOfCardItemRow" *ngIf="normalizedData.Depth <= 3">
					<td>
						<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnLightbulb"></i></div>
					</td>
					<td style="display: flex; flex-direction: column;">
						<div class="territoryCardBackOfCardItemText">Standards</div>
						<div class="territoryCardBackOfCardItemText" style="font-weight:700;">{{normalizedData.StandardTotal}}</div>
					</td>
				</tr>
				<tr class="territoryCardBackOfCardRowSpacer">
					<td colspan="2"></td>
				</tr>

				<tr class="territoryCardBackOfCardItemRow" *ngIf="normalizedData.Depth <= 4">
					<td>
						<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnBookmark"></i></div>
					</td>
					<td style="display: flex; flex-direction: column;">
						<div class="territoryCardBackOfCardItemText">Standards</div>
						<div class="territoryCardBackOfCardItemText" style="font-weight:700;">{{normalizedData.StrandTotal}}</div>
					</td>
				</tr>
				<tr class="territoryCardBackOfCardRowSpacer">
					<td colspan="2"></td>
				</tr>
				<tr class="territoryCardBackOfCardItemRow" *ngIf="normalizedData.Depth <= 5">
					<td>
						<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnListOl"></i></div>
					</td>
					<td style="display: flex; flex-direction: column;">
						<div class="territoryCardBackOfCardItemText">Performance Indicators</div>
						<div class="territoryCardBackOfCardItemText" style="font-weight:700;">{{normalizedData.PerformanceIndicator}}</div>
					</td>
				</tr>
				<tr class="territoryCardBackOfCardRowSpacer">
					<td colspan="2"></td>
				</tr>
			</table>
		</div>

		<div *ngIf="normalizedData.tCardType===tCardType.Institution">
			<table style="margin-top: 10px;">
				<tr class="territoryCardBackOfCardItemRow">
					<td>
						<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnBuildingColumns"></i></div>
					</td>
					<td style="display: flex; flex-direction: column;">
						<div class="territoryCardBackOfCardItemText">{{normalizedData.AtAGlance_Institution.SchoolYear}} Year</div>
						<div class="territoryCardBackOfCardItemText" style="font-weight:700;">{{normalizedData.AtAGlance_Institution.Type}}</div>
					</td>
				</tr>
				<tr class="territoryCardBackOfCardRowSpacer">
					<td colspan="2"></td>
				</tr>
				<tr class="territoryCardBackOfCardItemRow">
					<td>
						<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnUsers"></i></div>
					</td>
					<td style="display: flex; flex-direction: column;">
						<div class="territoryCardBackOfCardItemText">Undergraduate Students</div>
						<div class="territoryCardBackOfCardItemText" style="font-weight:700;">{{toCommaNumber(normalizedData.AtAGlance_Institution.StudentSize)}}</div>
					</td>
				</tr>
				<tr class="territoryCardBackOfCardRowSpacer">
					<td colspan="2"></td>
				</tr>
				<tr class="territoryCardBackOfCardItemRow">
					<td>
						<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnLocationDot"></i></div>
					</td>
					<td style="display: flex; flex-direction: column;">
						<div class="territoryCardBackOfCardItemText">Location</div>
						<div class="territoryCardBackOfCardItemText" style="font-weight:700;">{{normalizedData.AtAGlance_Institution.Locale.split(':')[0]}}</div>
					</td>
				</tr>
				<tr class="territoryCardBackOfCardRowSpacer">
					<td colspan="2"></td>
				</tr>
				<tr class="territoryCardBackOfCardItemRow">
					<td>
						<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnPencil"></i></div>
					</td>
					<td style="display: flex; flex-direction: column;">
						<div class="territoryCardBackOfCardItemText">Classrooms</div>
						<div class="territoryCardBackOfCardItemText" style="font-weight:700;">{{normalizedData.AtAGlance_Institution.Classroom}}</div>
					</td>
				</tr>
			</table>
		</div>

		<div *ngIf="normalizedData.tCardType===tCardType.Degree">
			<table style="margin-top: 10px;">
				<tr class="territoryCardBackOfCardItemRow">
					<td>
						<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnBuildingColumns"></i></div>
					</td>
					<td style="display: flex; flex-direction: column;">
						<div class="territoryCardBackOfCardItemText">Institutions</div>
						<div class="territoryCardBackOfCardItemText" style="font-weight:700;">{{normalizedData.Institutions}}</div>
					</td>
				</tr>
				<tr class="territoryCardBackOfCardRowSpacer">
					<td colspan="2"></td>
				</tr>
				<tr class="territoryCardBackOfCardItemRow">
					<td>
						<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnPencil"></i></div>
					</td>
					<td>
						<div class="territoryCardBackOfCardItemText">Courses</div>
						<br />
						<div class="territoryCardBackOfCardItemText">{{normalizedData.CourseTotal}}</div>
					</td>
				</tr>
				<tr class="territoryCardBackOfCardRowSpacer">
					<td colspan="2"></td>
				</tr>
				<tr class="territoryCardBackOfCardItemRow">
					<td>
						<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnBriefcase"></i></div>
					</td>
					<td style="display: flex; flex-direction: column;">
						<div class="territoryCardBackOfCardItemText">Occupations</div>
						<div class="territoryCardBackOfCardItemText" style="font-weight:700;">{{normalizedData.OccupationTotal}}</div>
					</td>
				</tr>
				<tr class="territoryCardBackOfCardRowSpacer">
					<td colspan="2"></td>
				</tr>
				<tr class="territoryCardBackOfCardItemRow">
					<td>
						<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnDollarSign"></i></div>
					</td>
					<td>
						<div class="territoryCardBackOfCardItemText">Average Annual Salary</div>
					</td>
				</tr>
				<tr class="territoryCardBackOfCardItemRow">
					<td></td>
					<td>
						<div class="territoryCardBackOfCardItemText">{{normalizedData.AverageAnnualSalary !== null ? normalizedData.AverageAnnualSalary : 'N/A'}}</div>
					</td>
				</tr>
			</table>
		</div>

		<div *ngIf="normalizedData.tCardType===tCardType.FieldsOfStudy || normalizedData.tCardType===tCardType.CSCDegree">
			<table style="margin-top: 10px;">
				<tr class="territoryCardBackOfCardItemRow">
					<td>
						<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnGraduationCap"></i></div>
					</td>
					<td style="display: flex; flex-direction: column;">
						<div class="territoryCardBackOfCardItemText">Number of Graduates</div>
						<div class="territoryCardBackOfCardItemText" style="font-weight:700;">{{toCommaNumber(normalizedData.AtAGlance_CSCDegree.NumberOfGraduation)}}</div>
					</td>
				</tr>
				<tr class="territoryCardBackOfCardRowSpacer">
					<td colspan="2"></td>
				</tr>
				<tr class="territoryCardBackOfCardItemRow">
					<td>
						<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnCreditCard"></i></div>
					</td>
					<td style="display: flex; flex-direction: column;">
						<div class="territoryCardBackOfCardItemText">Median Total Debt</div>
						<div class="territoryCardBackOfCardItemText" style="font-weight:700;">{{toDollar(normalizedData.AtAGlance_CSCDegree.MedianTotalDebt)}}</div>
					</td>
				</tr>
				<tr class="territoryCardBackOfCardRowSpacer">
					<td colspan="2"></td>
				</tr>
				<tr class="territoryCardBackOfCardItemRow">
					<td>
						<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnDollarSign"></i></div>
					</td>
					<td style="display: flex; flex-direction: column;">
						<div class="territoryCardBackOfCardItemText">Median Earnings</div>
						<div class="territoryCardBackOfCardItemText" style="font-weight:700;">{{toDollar(normalizedData.AtAGlance_CSCDegree.MedianEarnings)}}</div>
					</td>
				</tr>
				<tr class="territoryCardBackOfCardRowSpacer">
					<td colspan="2"></td>
				</tr>
				<tr class="territoryCardBackOfCardItemRow">
					<td>
						<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnFileInvoiceDollar"></i></div>
					</td>
					<td style="display: flex; flex-direction: column;">
						<div class="territoryCardBackOfCardItemText">Monthly Loan Payment</div>
						<div class="territoryCardBackOfCardItemText" style="font-weight:700;">{{toDollar(normalizedData.AtAGlance_CSCDegree.MonthlyLoanPayment)}}</div>
					</td>
				</tr>
				<tr class="territoryCardBackOfCardRowSpacer">
					<td colspan="2"></td>
				</tr>
				<tr class="territoryCardBackOfCardItemRow">
					<td>
						<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnCalendarCheck"></i></div>
					</td>
					<td style="display: flex; flex-direction: column;">
						<div class="territoryCardBackOfCardItemText">Monthly Earnings</div>
						<div class="territoryCardBackOfCardItemText" style="font-weight:700;">{{toDollar(normalizedData.AtAGlance_CSCDegree.MonthlyEarnings)}}</div>
					</td>
				</tr>
			</table>
		</div>

		<div *ngIf="normalizedData.tCardType===tCardType.Podcast">
			<table style="margin-top: 10px;">
				<tr class="territoryCardBackOfCardItemRow">
					<td>
						<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnCalendar"></i></div>
					</td>
					<td style="display: flex; flex-direction: column;">
						<div class="territoryCardBackOfCardItemText">Latest Episode</div>
						<div class="territoryCardBackOfCardItemText" style="font-weight:700;">{{normalizedData.AtAGlance_Podcast.ReleaseDate}}</div>
					</td>
				</tr>
				<tr class="territoryCardBackOfCardRowSpacer">
					<td colspan="2"></td>
				</tr>
				<tr class="territoryCardBackOfCardItemRow">
					<td>
						<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnMicrophoneLines"></i></div>
					</td>
					<td>
						<div class="territoryCardBackOfCardItemText">Artist Name</div>
						<br />
						<div class="territoryCardBackOfCardItemText" style="font-weight:700;">{{normalizedData.AtAGlance_Podcast.ArtistName}}</div>
					</td>
				</tr>
			</table>
		</div>

		<div *ngIf="normalizedData.tCardType===tCardType.PodcastEpisode">
			<table style="margin-top: 10px;">
				<tr class="territoryCardBackOfCardItemRow">
					<td>
						<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnCalendar"></i></div>
					</td>
					<td style="display: flex; flex-direction: column;">
						<div class="territoryCardBackOfCardItemText">Release Date</div>
						<div class="territoryCardBackOfCardItemText" style="font-weight:700;">{{normalizedData.AtAGlance_PodcastEpisode.ReleaseDate}}</div>
					</td>
				</tr>
				<tr class="territoryCardBackOfCardRowSpacer">
					<td colspan="2"></td>
				</tr>
				<tr class="territoryCardBackOfCardItemRow">
					<td>
						<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnClock"></i></div>
					</td>
					<td>
						<div class="territoryCardBackOfCardItemText">Track Time</div>
						<br />
						<div class="territoryCardBackOfCardItemText" style="font-weight:700;">{{normalizedData.AtAGlance_PodcastEpisode.TrackTime}} Minutes</div>
					</td>
				</tr>
				<tr class="territoryCardBackOfCardRowSpacer">
					<td colspan="2"></td>
				</tr>
				<tr class="territoryCardBackOfCardItemRow">
					<td>
						<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnStar"></i></div>
					</td>
					<td>
						<div class="territoryCardBackOfCardItemText">Rating</div>
						<br />
						<div class="territoryCardBackOfCardItemText" style="font-weight:700;">{{normalizedData.AtAGlance_PodcastEpisode.Rating}}</div>
					</td>
				</tr>
			</table>
		</div>

		<div *ngIf="normalizedData.tCardType===tCardType.Training">
			<table style="margin-top: 10px;">
				<tr class="territoryCardBackOfCardItemRow">
					<td>
						<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnSchool"></i></div>
					</td>
					<td style="display: flex; flex-direction: column;">
						<div class="territoryCardBackOfCardItemText">Institution</div>
						<div class="territoryCardBackOfCardItemText" style="font-weight:700;">
							<div>
								{{normalizedData.AtAGlance_Training.SchoolName}}
							</div>
							<div>
								{{normalizedData.AtAGlance_Training.City}},
								{{normalizedData.AtAGlance_Training.State}}
								{{normalizedData.AtAGlance_Training.ZipCode}}
							</div>
							<div>
								{{normalizedData.AtAGlance_Training.Phone}}
							</div>
						</div>
					</td>
				</tr>
				<tr class="territoryCardBackOfCardRowSpacer">
					<td colspan="2"></td>
				</tr>
				<tr class="territoryCardBackOfCardItemRow">
					<td>
						<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnGraduationCap"></i></div>
					</td>
					<td>
						<div class="territoryCardBackOfCardItemText">Program Length</div>
						<br />
						<div class="territoryCardBackOfCardItemText" style="font-weight:700;">
							<ng-container *ngIf="normalizedData.AtAGlance_Training.ProgramLength != null && normalizedData.AtAGlance_Training.ProgramLength.length > 0">
								<div *ngFor="let p of normalizedData.AtAGlance_Training.ProgramLength">
									{{p}}
								</div>
							</ng-container>
							<div *ngIf="normalizedData.AtAGlance_Training.ProgramLength.length === 0">
								N/A
							</div>
						</div>
					</td>
				</tr>
			</table>
		</div>

		<div *ngIf="normalizedData.tCardType===tCardType.Military">
			<table style="margin-top: 10px;">
				<tr class="territoryCardBackOfCardItemRow">
					<td>
						<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnPersonMilitaryRifle"></i></div>
					</td>
					<td style="display: flex; flex-direction: column;">
						<div class="territoryCardBackOfCardItemText">MOS Code</div>
						<div class="territoryCardBackOfCardItemText" style="font-weight:700;"><a href="{{normalizedData.AtAGlance_Military.MOSUrl}}" target="_blank">{{normalizedData.AtAGlance_Military.MOSCode}}</a></div>
					</td>
				</tr>
				<tr class="territoryCardBackOfCardRowSpacer">
					<td colspan="2"></td>
				</tr>
				<tr *ngIf="normalizedData.AtAGlance_Military.MCId.length > 0" class="territoryCardBackOfCardItemRow">
					<td>
						<div class="territoryCardIconBackOfCardAtAGlance"><i class="icnBriefcase"></i></div>
					</td>
					<td>
						<div class="territoryCardBackOfCardItemText">Careers In Military</div>
						<br />
						<div class="territoryCardBackOfCardItemText" style="font-weight:700;"><a href="{{normalizedData.AtAGlance_Military.MCUrl}}" target="_blank">{{normalizedData.AtAGlance_Military.MCId}}</a></div>
					</td>
				</tr>
			</table>
		</div>
	</div>
</div>
